module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('div', {
    staticClass: "footer-left pull-left"
  }, [_c('div', [_c('p', [_vm._v("南方水泥有限公司 版权所有")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-right pull-right"
  }, [_c('div', {
    attrs: {
      "id": "footer-phone"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/imgs/footer-phone.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("服务电话：021-68989037")]), _vm._v(" "), _c('p', [_vm._v("监督电话：021-68989150")]), _vm._v(" "), _c('p', [_vm._v("服务时间：周一至周五 上午9:00至下午17:00")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-334bc2a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 38
// module chunks = 4 5 6 7 8 9 10 11 12 13